<template>
  <div class="order-detail">
    <!-- 引入公共头部 -->
    <dg-header :showBack="true" title="订单详情"></dg-header>
    <div class="order-detail-wrap" v-if="odData">
      <!-- 等待商家发货 1.待支付 2.待发货 3.已发货 4.已完成 5.已收款 -->
      <div class="order-detail-head">
        <span class="od-head-img icon-span">
          <img src="@/assets/images/state-unshipped.png" alt v-if="odData.status ===1">
          <img src="@/assets/images/state-unpayment.png" alt v-else-if="odData.status ===2">
          <img src="@/assets/images/state-shipped.png" alt v-else-if="odData.status ===3">
          <img src="@/assets/images/state-completed.png" alt v-else-if="odData.status ===4">
          <img src="@/assets/images/state-unpayment.png" alt v-else-if="odData.status ===5">
          <img src="@/assets/images/state-closed.png" alt v-else>
        </span>
        <div class="od-head-title">
          <p v-if="odData.status ===1">
            待付款 <span class="fs24" v-if="odData.buyType ===1">{{times(time)}} 若未支付，订单自动关闭</span>
          </p>
          <p v-else-if="odData.status ===2">待发货</p>
          <p v-else-if="odData.status ===3">已发货</p>
          <p v-else-if="odData.status ===4">已完成</p>
          <p v-else-if="odData.status ===6">订单已超过支付时间，已取消</p>
          <p v-else-if="odData.status ===8">已失败</p>
        </div>
      </div>

      

      <div class="order-detail-con">
       <!-- 如果是团购商品显示拼团成员信息 -->
      <div class="group-bulk" v-if="odData.buyType === 2">
        <!--当时间不等于0，且拼团人数不够时-->
        <div v-if="odData.join != 1 || odData.groupOrder_doc.length > 0">
          <p class="group-bulk-title" 
           v-if="odData.groupOrder_doc[0].groupBuyEndTime > 0 && odData.groupOrder_doc[0].groupBuyPeople > odData.groupOrder_doc[0].participateNum">
          <span class="group-bulk-state">[拼团中]</span> 
          差<span class="group-bulk-state">{{odData.groupOrder_doc[0].groupBuyPeople - odData.groupOrder_doc[0].participateNum}}</span>人，
          {{times(time)}}
          </p>
          <!--当时间不等于0，且拼团人数够了时-->
          <p class="group-bulk-title" 
             v-if="odData.groupOrder_doc[0].groupBuyPeople === odData.groupOrder_doc[0].participateNum">
            <span class="group-bulk-state" >[拼团成功]</span> 
            {{odData.status === 2 ? '等待商家发货' : odData.status === 3 ? '您的宝贝已发货' : '拼团已完成' }}
            </p>
          <!--当时间等于0，且拼团人数不够时-->
          <p class="group-bulk-title" 
            v-if="odData.groupOrder_doc[0].groupBuyEndTime <= 0 && odData.groupOrder_doc[0].groupBuyPeople > odData.groupOrder_doc[0].participateNum">
            <span class="group-bulk-state">[拼团失败]</span> 
            拼团时间过期，信用额度已原路返回。
            </p>
        </div>
        <p class="group-bulk-title" 
           v-else>
          <span class="group-bulk-state">[未开始]</span> 
          付款后，发起拼团 {{times(time)}}
          </p>
        <ul class="group-bulk-ul">
           <!--参团展示-->
          <li v-if="odData.groupOrder_doc.length === 0"></li> 
          <li class="group-bulk-li"  v-for="(userItem, i) in odData.groupOrder_doc[0].userInfo" :key="i" v-else>
            <span class="group-bulk-span default-photo" :class="userName === userItem.nickName ? 'self-br' : ''">
              <img :src="userItem.portrait" alt="">
            </span>
            <p class="group-bulk-p">{{userItem.nickName + (i===0 ? '(团长)' : '')}}</p>
          </li>
          <!--开团展示-->
          <li class="group-bulk-li open-group" v-if="odData.status === 1">
            <span class="group-bulk-span default-photo">
              <!-- <img src="@/assets/images/disable-reduce-icon.png" alt=""> -->
            </span>
            <p class="group-bulk-p">待支付</p>
          </li>
        </ul>
      </div>
        <!-- 商品信息 -->
        <ul class="order-info-ul">
          <li class="order-info" v-for="(odItem, index) in odData.comInfoList" :key="index">
            <div class="order-info-left">
              <img :src="odItem.comImage" alt>
            </div>
            <div class="order-info-right">
              <div class="order-info-flex">
                <div class="order-info-middle">
                  <p class="order-info-text">{{odItem.comName}}</p>
                  <p class="order-info-price">
                    <span class="fs24">JPY</span> {{odItem.price | setNumber }}
                  </p>
                </div>
              
              </div>
                <span class="order-state-text" ><span class="p-number">共计<i>{{odItem.count}}</i>件商品</span>{{odItem.comStatus | setStatus}}</span>
            </div>
          </li>
        </ul>
        <!-- 订单编号 -->
        <div class="order-number-date">
          <p class="order-number">订单编号：{{odData.orderNumber}}</p>
          <p  v-if="odData.createDate ">下单时间：{{odData.createDate | changeTime}}</p>
          <p  v-if="odData.paymentDate">付款时间：{{odData.paymentDate | changeTime}}</p>
          <p  v-if="odData.sendDate ">发货时间：{{odData.sendDate | changeTime}}</p>
          <p  v-if="odData.completeDate">完成时间：{{odData.completeDate | changeTime}}</p>
          <p class="pay-methods">支付方式：信用额度</p>
        </div>
        <!-- 配送方式 -->
        <div class="delivery-methods">
          <div class="item-status-bar">
            <p class="item-status-p">配送方式</p>
            <p class="status-btn">
              快递发货
              <!-- <span class="fs24">JPY</span> 20 -->
            </p>
          </div>
          <div class="item-status-bar">
            <p class="item-status-p">买家留言：</p>
            <p class="nothing">{{odData.remark || '暂无留言'}}</p>
          </div>
        </div>
        <!-- 商品总额 -->
        <div class="goods-total">
          <div class="item-status-bar">
            <p class="item-status-p">商品总额</p>
            <p class="status-btn">
              <span class="fs24">JPY</span> {{odData.totalCost | setNumber}}
            </p>
          </div>
        </div>
        <!-- 应付款 -->
        <div class="payable">
          {{odData.status === 1 ? '应付款' : '实付款'}}
          <p>
            <span class="fs24">JPY</span> {{odData.totalCost | setNumber}}
          </p>
        </div>
      </div>
    </div>
    <div class="dg-no-order" v-if="flag">获取订单详情失败</div>
  </div>
</template>
<script>
import DgHeader from "@/components/header";
import api from '@/server'
export default {
  data() {
    return {
      // 订单详情数据
      odData: '',
      flag: false,
      userName: '',
      time:0,
      ticker: null
    };
  },
  components: {
    DgHeader
  },
  created () {
    // this.odData = this.setStatus(this.odData);
    this.userName = JSON.parse(localStorage.getItem('userInfo')).nickName;
    this.getOrderDetails();
  },
  methods: {
    // 根据id获取订单详情
    getOrderDetails() {
      api.getOrderDetails({
        orderNumber: this.$route.query.id,
        type: 'NORAM'
      }).then(res=> {
        if(res.code === 200 && res.data) {
          this.odData = res.data;
          if(this.odData.buyType === 2 && this.odData.join !== 0) {
            if(this.odData.status === 1) {
              this.time = this.odData.endTime;
            } else {
              this.time = this.odData.groupOrder_doc[0].groupBuyEndTime;
            } 
            this.beginTimer();
          }else if(this.odData.buyType === 1){
            this.time = this.odData.endTime;
            this.beginTimer();
          } 
        } else {
          this.flag = true
        }
      }).catch(err=> {
        console.log(err)
        this.flag = true;
      })
    },
    // 计算时间戳
    times(time) {
      if (time >= 0) {
        let str = "";
        let h = Math.floor(time / 1000 / 60 / 60);
        let m = Math.floor((time / 1000 / 60) % 60);
        let s = Math.floor((time / 1000) % 60);
        h = h < 10 ? "0" + h : h;
        m = m < 10 ? "0" + m : m;
        s = s < 10 ? "0" + s : s;
        if(this.odData.status === 1) {
          str = '剩余支付时间:'+h + ":" + m + ":" + s;
        } else {
          str = '剩余成团时间:'+h + ":" + m + ":" + s;
        }
        
        return str;
      } else {
        return "拼团已结束";
      }
    },
     // 计算倒计时的时间戳
    beginTimer() {
      this.ticker = setInterval(() => {
        // for (let i = 0, len = this.newDate.groupOrder_doc.length; i < len; i++) {
        //   const item = this.newDate.groupOrder_doc[i];
        //   if (item.groupBuyEndTime > 0) {
        this.time = this.time - 1000;
        //   }
        // }
      }, 1000);
    },
    destroyed() {
      window.clearInterval(this.ticker);
      this.ticker = null;
    },
  }
};
</script>
<style lang="scss" scoped>
.order-detail{
  overflow: hidden;
}
.order-detail-wrap {
  margin-top:88px;
  padding-bottom: 88px;
   /*如果是团购商品显示拼团成员信息*/
    .group-bulk{
      background: $bg02;
      padding: 30px;
      border-radius: $br30;
      box-shadow: $box-shadow3;
      margin-bottom: 8px;
      .self-br{
          border: 2px solid $fc04;
      }
      .group-bulk-title{
        .group-bulk-state{
          color: $fc04;
        }
      }
      .group-bulk-ul{
        display: table;
        text-align: center;
        margin: 0 auto;
        margin-top: 10px;
        .open-group{
          color: $fc04;
          .group-bulk-span{
            border: 2px solid $fc04;
          }
        }
        .group-bulk-li{
          width: 80px;
          margin-right: 30px;
          float: left;
          margin-top: 15px;
          .group-bulk-span{
            display: inline-block;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            overflow: hidden;
            >img{
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .group-bulk-p{
            text-align: center;
            font-size: 24px;
            @include ellipsis();
          }
        }
      }
    }
  .fs24 {
    font-size: 24px;
  }
  .icon-span {
    width: 40px;
    height: 40px;
    display: inline-block;
    margin-right: 24px;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  // 等待商家发货
  .order-detail-head {
    width: 100%;
    // height: 80px;
    background: $bg02;
    padding: 20px 30px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .od-head-title {
      font-size: 28px;
      color: $fc03;
    }
    .linght-tip {
      font-size: 24px;
      color: $fc09;
    }
  }
  .order-detail-con {
    width: 100%;
    padding: 30px 30px 0 30px;
    box-sizing: border-box;
    > div:not(:last-child),
    .order-info-ul {
      width: 100%;
      padding: 30px 30px;
      box-sizing: border-box;
      background: $bg02;
      border-radius: $br30;
      box-shadow: $box-shadow3;
      margin-bottom: 8px;
    }
    // 收货地址，姓名，电话等
    .address-info {
      display: flex;
      align-items: center;
      .address-info-dsc {
        flex: 1;
        overflow: hidden;
        .info-base {
          font-size: 28px;
          color: $fc03;
          > span {
            font-size: 24px;
            color: $fc09;
            margin-left: 8px;
          }
        }
        .info-addr {
          font-size: 24px;
          color: $fc09;
          margin-top: 10px;
          @include moreEllipsis(2);
        }
      }
    }
    // 商品信息
    .order-info {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .order-info-left {
        width: 150px;
        height: 160px;
        border: 1px solid $bc01;
        border-radius: $br20;
        overflow: hidden;
        margin-right: 24px;
        flex-shrink: 0;
        border: 2px solid $bc04;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .order-info-right {
        flex: 1;
        // justify-content: space-around;
        overflow: hidden;
        .order-info-flex {
          display: flex;
          align-items: center;
          .order-info-middle {
            flex: 1;
            overflow: hidden;
            .order-info-text {
              font-size: 28px;
              color: $fc06;
              margin: 10px auto 20px;
              @include ellipsis();
            }
            .order-info-price {
              font-size: 30px;
              color: $fc04;
            }
          }
          .order-info-num {
            font-size: 32px;
            color: $fc06;
            flex-shrink: 0;
          }
        }
        .order-state-text {
          font-size: 28px;
          color: $fc06;
          text-align: right;
          // margin-right: 30px;
          float: right;
          .p-number{
            margin-right: 30px; 
             font-size: 24px
          }
          i{
            color: $fc04;
            font-style: normal
          }
        }
      }
    }
    // 订单编号
    .order-number-date {
      font-size: 28px;
      color: $fc09;
      p{
        margin-bottom: 24px;
        line-height: 1;
      }
      // .order-number,
      // .order-date,
      // .pay-methods {
      //   font-size: 28px;
      //   color: $fc09;
      //   margin-bottom: 24px;
      // }
      // .pay-methods {
      //   margin-bottom: 0;
      // }
    }
    // 配送方式
    .delivery-methods,
    .goods-total {
      .item-status-bar {
        padding: 16px 0;
        display: flex;
        justify-content: space-between;
        .item-status-p {
          font-size: 28px;
          color: $bc02;
          min-width: 150px;
        }
        .status-btn {
          @include resetButton();
          background: none;
          font-size: 28px;
          color: $fc04;
        }
        .nothing {
          font-size: 26px;
          color: $fc06;
          // @include ellipsis();
          overflow: hidden;
          word-wrap: break-word;
        }
      }
    }
    // 商品总额
    .goods-total {
    }
    // 应付款
    .payable {
      text-align: right;
      margin-top: 30px;
      font-size: 28px;
      color: $fc06;
      width: 100%;
      padding: 0 30px;
      box-sizing: border-box;
      > p {
        display: inline-block;
        color: $fc04;
        margin-left: 0;
      }
    }
  }
}
</style>
